import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';
import PageHeader from '@zenbusiness/zui/PageHeader';
import Stack from '@zenbusiness/zui/Stack';

const HomeSection = ({
  title = '', subtitle = null, slots = {}, children, slotProps
}) => (
  <Stack spacing={1.5}>
    <PageHeader
      slots={slots}
      subtitle={subtitle}
      title={title}
      paddingX={2}
      sx={{ marginBottom: slots?.end ? 4 : 0 }}
      slotProps={slotProps}
    />
    <Box paddingX={2}>{children}</Box>
  </Stack>
);

HomeSection.propTypes = {
  title: PropTypes.node,
  subtitle: PropTypes.node,
  slots: PropTypes.shape({
    end: PropTypes.node,
    aside: PropTypes.node
  }),
  slotProps: PropTypes.shape({
    primary: PropTypes.shape({})
  }),
  children: PropTypes.node.isRequired
};

export default HomeSection;
